import React from 'react';
import { TaxLiability } from '../types';

interface HeadlineFiguresProps {
  payeLiabilities: TaxLiability[];
  vatLiabilities: TaxLiability[];
}

function formatCurrency(amount: number): string {
  return '£' + amount.toLocaleString('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function calculateDueTotal(liabilities: TaxLiability[]): number {
  return liabilities
    .filter((l) => l.status === 'DUE')
    .reduce((sum, l) => sum + l.amount, 0);
}

const HeadlineFigures: React.FC<HeadlineFiguresProps> = ({ payeLiabilities, vatLiabilities }) => {
  const payeTotal = calculateDueTotal(payeLiabilities);
  const vatTotal = calculateDueTotal(vatLiabilities);

  return (
    <div className="headline-figures">
      <div className="headline-box">
        <div className="headline-label">Current PAYE liability</div>
        <div className="headline-amount">{formatCurrency(payeTotal)}</div>
      </div>
      <div className="headline-box">
        <div className="headline-label">Current VAT liability</div>
        <div className="headline-amount">{formatCurrency(vatTotal)}</div>
      </div>
    </div>
  );
};

export default HeadlineFigures;
